<div class="dialog">
  <header class="dialog__bar">
    <h2 mat-dialog-title class="dialog__title">{{ table.caption || ('Tabella' | translate) }}</h2>
    <button mat-button type="button" class="dialog__copy" (click)="copy()">
      <mat-icon fontSet="material-icons-round" class="s-18" aria-hidden="true">{{ copied ? 'check' : 'content_copy' }}</mat-icon>
      {{ (copied ? 'Copiata' : 'Copia per Excel') | translate }}
    </button>
    <button mat-icon-button type="button" mat-dialog-close [attr.aria-label]="'Chiudi' | translate">
      <mat-icon fontSet="material-icons-round">close</mat-icon>
    </button>
  </header>
  <div class="dialog__scroll" tabindex="0" [attr.aria-label]="table.caption || ('Tabella' | translate)">
    <table class="grid grid--full">
      <thead>
        <tr>
          @for (cell of table.header; track $index) {
            <th scope="col" [class.is-numeric]="table.numeric[$index]" [innerHTML]="cell"></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of table.rows; track $index) {
          <tr>
            @for (cell of row; track $index) {
              @if ($first) {
                <th scope="row" [innerHTML]="cell"></th>
              } @else {
                <td [class.is-numeric]="table.numeric[$index]" [innerHTML]="cell"></td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
